// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2-6fo","content":"LoadingAlert_content__2BfOH"};